import DashBordScreen from "overrides/theme/wom/base/Pages/HomeScreens/HomeScreen/DashBoardScreen"
import OrderScreen from "overrides/theme/wom/base/Pages/OrderScreens/OrderScreen"
import ProfileScreen from "pages/UserScreens/ProfileScreen/ProfileScreen"
import ReportPage from "pages/Report/ReportPage"
import TransferScreen from "pages/TransferScreens/TransferScreen"
import ConfirmOrderScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen"
import PackageScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Package/PackageScreen"
import DeliveryScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Delivery/DeliveryScreen"
import TransitScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Transit/TransitScreen"
import PickupScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Pickup/PickupScreen"
import DeliveredScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Delivered/DeliveredSreen"
import ErrorHandler from "components/Commons/Error/ErrorHandler"
import { IRouteComponent } from "interfaces/IRoute"
import { validateAccessRouteOrder } from "helpers/validationRoutesHelper"
import ClosedScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Closed/ClosedScreen"
import CanceledScreen from "pages/DetailOrderScreens/Canceled/CanceledScreen"
import SearchResultsScreen from "overrides/theme/wom/base/Pages/SearchResults/SearchResultsScreen"
import { EShippinggroupStatus } from "enums/shippinggroupEmun"
import OrderDetailScreen from "pages/DetailOrderScreens/Custom/OrderDetailScreen"
import ManifestScreen from "pages/ManifestScreens/ManifestScreen"

const RouteListWom: IRouteComponent[] = [
  {
    path: "/",
    name: "DashBordScreen",
    component: DashBordScreen,
    exact: true,
  },
  {
    path: "/dashboard",
    name: "DashBordScreen",
    component: DashBordScreen,
    exact: true,
  },
  {
    path: "/profile",
    name: "ProfileScreen",
    component: ProfileScreen,
    exact: true,
  },
  {
    path: "/order/:type",
    name: "OrderPage",
    component: OrderScreen,
    exact: true,
    handleValidateParams: validateAccessRouteOrder,
    redirectPath: "/",
  },
  {
    path: ["/order/confirmation/:shippingGroupId/:id"],
    name: "oderDetailConfrim",
    component: ConfirmOrderScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.confirmation,
  },
  {
    path: ["/order/package/:shippingGroupId/:id"],
    name: "oderDetailPackage",
    component: PackageScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.package,
  },
  {
    path: ["/order/delivery/:shippingGroupId/:id"],
    name: "oderDetailDelivery",
    component: DeliveryScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.delivery,
  },
  {
    path: ["/order/transit/:shippingGroupId/:id"],
    name: "oderDetailTransit",
    component: TransitScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.transit,
  },

  {
    path: ["/order/in_transit_for_reception/:shippingGroupId/:id"],
    name: "oderDetailTransit",
    component: OrderDetailScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.transit,
  },

  {
    path: ["/order/in_transit_for_reception_opl/:shippingGroupId/:id"],
    name: "oderDetailTransit",
    component: OrderDetailScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.transit,
  },

  {
    path: ["/order/pickup/:shippingGroupId/:id"],
    name: "oderDetailPickup",
    component: PickupScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.pickup,
  },
  {
    path: ["/order/delivered/:shippingGroupId/:id"],
    name: "oderDetailDelivered",
    component: DeliveredScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.delivered,
  },
  {
    path: ["/order/closed/:shippingGroupId/:id"],
    name: "oderDetailClosed",
    component: ClosedScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.closed,
  },
  {
    path: ["/order/canceled/:shippingGroupId/:id"],
    name: "oderDetailCanceled",
    component: CanceledScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.canceled,
  },
  {
    path: ["/order/rejected/:shippingGroupId/:id"],
    name: "oderDetailRejected",
    component: CanceledScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.rejected,
  },

  {
    path: "/search/:query/:optionFilter",
    name: "SearchResultsPage",
    component: SearchResultsScreen,
    exact: true,
  },

  {
    path: "/report",
    name: "ReportPage",
    component: ReportPage,
    exact: true,
  },

  {
    path: "/page/transfer",
    name: "TransferScreen",
    component: TransferScreen,
    exact: true,
  },

  {
    path: "/page/manifest",
    name: "TransferScreen",
    component: ManifestScreen,
    exact: true,
  },

  {
    path: "*",
    name: "notFound",
    component: ErrorHandler,
    exact: false,
  },
]

export default RouteListWom
